import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
// import OrderStatus from "./OrderStatus";
// import Notifications from "./Notifications";

// import RevenueByLocation from "./RevenueByLocation";
// import LatestTransation from "./LatestTransation";
import axios from "axios";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,

} from "reactstrap";
// import SensorModal from "./Sensor";
import StationCycleTime from "./StationCycleTime";
import LiveStationCycleTime from "./LiveStationCycleTime";
import AnalysisUserPanel from "./AnalysisUserPanel";
import PartCountByDate from "./PartCountByDate";


const AdvancedAnalysis = () => {
   // const authToken = JSON.parse(localStorage.getItem("authUser")).token;
//   const [editMode, setEditMode] = useState(true);
//   const [indicatorsModal, setIndicatorsModal] = useState(false);
//   const [alarms, setAlarms] = useState([]);
//     const [machines, setMachines] = useState([]);
//     const [selectedMachine, setSelectedMachine] = useState("");
// const [indicatorsData, setIndicatorsData] = useState([]);
   
//  const fetchAlarm = async () => {
//     try {
//       // setIsLoading(true)
//    const response = await axios.get("https://api.hanoch.in/equipment/alarms/?type=20");
//    setAlarms(response);
  
     
//       } catch (error) {
//       if (error?.response?.status === 401) {
//         localStorage.removeItem("access");
//         localStorage.removeItem("role");
//       }
//        else {
//         console.error("Error fetching data:", error);
//       }
//     } finally {
//       // setIsLoading(false);
//     }
//   };
//     useEffect(() => {
//     fetchAlarm();
//   }, [ ]);
const [loading, setLoading] = useState(true);

  const [data, setData] = useState(null);
 const machineId = Number(localStorage.getItem("selectedMachineId")) || 74;


  const fetchShiftData = async () => {
    try {
       setLoading(true);
      const res = await axios.get(
        `https://api.hanoch.in/api/mcc-shift-data/?machine_id=${machineId}`
      );
      setData(res);
    } catch (err) {
      console.error("API Error", err);
    } finally {
    setLoading(false);
  }
  };

  useEffect(() => {
    fetchShiftData();
    const interval = setInterval(fetchShiftData, 60000); // 🔁 every minute
    return () => clearInterval(interval);
  }, [machineId]);

  // if (!data) return null;

const metrics = data?.metrics || {};

    document.title = "Advanced Analysis";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    {/* <Row>                      
                        <Col xl={5} >
                            <Card style={{ height: "100%" }}>
                                <CardBody>
                                    <model-viewer
                                        src="http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/images/drawing-1740229095581-852530385.GLB"
                                        alt="3D Model"
                                        auto-rotate
                                        camera-controls
                                        style={{ width: "100%", height: "400px" }}>
                                    </model-viewer>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xl={7} >
                            <Card style={{ height: "100%" }}>
                                <CardBody>
                                   
                                    <div className="w-50 align-center " >
                                        <p>Video coming soon</p>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={5} >
                            <Card style={{ height: "100%" }}>
                                <CardBody>
                                    <div className="w-30 p-4 bg-gray-100 min-h-screen">
                                        <div className="w-full max-w-md mx-auto shadow-md rounded-md p-4">
                                            <table className="table-auto w-full border-collapse">
                                                <thead>
                                                    <tr>
                                                        <th className="border-b-2 pb-2 px-5"><input type="checkbox" /></th>
                                                        <th className="border-b-2 px-5 pb-2 text-left">Title</th>
                                                        <th className="border-b-2 px-5 pb-2 text-left">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
   
        <button
        className="btn btn-primary"
        size="sm"
        style={{
          borderRadius: "6px",
          width: "28px",
          height: "28px",
          padding: "0px",
          fontSize: "18px",
        }}
        onClick={() => setIndicatorsModal(true)}
      >
         <i className="ri-add-line align-bottom me-0">
      </i>
      </button>

    {alarms.map((item, index) => (
          <tr key={index}>
                                                            <td className="py-2 text-center">
                                                                <input type="checkbox" />
                                                            </td>
                                                            <td className="py-2 text-center">{item.description}</td>
                                                            <td className="py-2 text-center">
                                                                <input type="checkbox" />
                                                            </td>
                                                        </tr>
    
    ))}
                                                    {["Sensor 1", "Sensor 2", "Sensor 3", "Sensor 4"].map((sensor, index) => (
                                                        <tr key={index}>
                                                            <td className="py-2 text-center">
                                                                <input type="checkbox" />
                                                            </td>
                                                            <td className="py-2 text-center">{sensor}</td>
                                                            <td className="py-2 text-center">
                                                                <input type="checkbox" />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <OverView partsDataMap={partsDataMap} />

                    </Row> */}


      <Breadcrumbs title="OptiMize" breadcrumbItem="Advanced Analysis" />
      <Card>
        <CardBody className="p-1">
 <div className="d-flex flex-wrap align-items-center mb-3"
            style={{
              gap: "12px",
              padding: "12px 16px",
              // backgroundColor: "#252b3b",
              color: "#c9d1d9",
              borderRadius: "6px",
              width: "100%"
            }}>
            <div className="d-flex align-items-center">
            <h5>Running Time: {data?.running_time}</h5>
             
            </div>
 {/* <div className="d-flex align-items-center"
 style={{
              backgroundColor: "#21262d",
              padding: "4px 10px",
              borderRadius: "6px",
              border: "1px solid #30363d"
            }}>
            <h5>Part number: {data?.part_no}</h5>
             
            </div> */}
    
            <div style={{
              // backgroundColor: "#21262d",
              padding: "4px 10px",
              borderRadius: "6px",
              border: "1px solid #30363d"
            }}>
             <h5>Part Name : {data?.part_name}</h5>
            </div>

            {/* Shift Selector */}
            <div className="d-flex align-items-center">
              <label style={{
                fontSize: "13px",
                marginRight: "6px",
                marginBottom: 0,
                color: "#8b949e"
              }}>Shift: {data?.shift}</label>
             
            </div>

    

            {/* Machine Status Indicator */}
            <div className="d-flex align-items-center ms-auto ">
              <div className="me-5">
                {/* <h6 className="mb-0">Last updated : {partsData?.last_updated} </h6> */}
              </div>
              <div className="me-2 blinking-text">
                <img
                  width="14"
                  height="14"
                  src={
                    data?.machine_status === "running"
                      ? "https://img.icons8.com/ios-filled/50/40C057/filled-circle.png"
                      : "https://img.icons8.com/ios-filled/50/FA5252/filled-circle.png"
                  }
                  alt={`machine-status-${data?.machine_status}`}
                />
              </div>
              <span style={{
                fontSize: "13px",
                fontWeight: "500"
              }}>Machine {data?.machine_status}</span>
            
            
            </div>
          </div>
        </CardBody>
      </Card>
    
  <Row>
  {[
    {
      icon: "ri-checkbox-circle-line",
      color: "text-success",
      label: "ORDER GOOD PRODUCTS",
      value: metrics["ORDER GOOD PRODUCTS"],
    },
    {
      icon: "ri-close-circle-line",
      color: "text-danger",
      label: "ORDER SCRAP PRODUCTS",
      value: metrics["ORDER SCRAP"],
    },
    {
      icon: "ri-group-line",
      color: "text-primary",
      label: "ORDER TOTAL PRODUCTS",
      value: metrics["ORDER TOTAL PRODUCTS"],
    },
    {
      icon: "ri-checkbox-circle-line",
      color: "text-success",
      label: "SHIFT GOOD PRODUCTS",
      value: metrics["SHIFT GOOD PRODUCTS"],
    },
    {
      icon: "ri-close-circle-line",
      color: "text-danger",
      label: "SHIFT SCRAP PRODUCTS",
      value: metrics["SHIFT SCRAP PRODUCTS"],
    },
    {
      icon: "ri-group-line",
      color: "text-primary",
      label: "SHIFT TOTAL PRODUCTS",
      value: metrics["SHIFT TOTAL PRODUCTS"],
    },
  ].map((item, idx) => (
    <Col xl={2} sm={6} key={idx}>
      <Card className="h-100">
        <CardBody
          className="d-flex flex-column justify-content-center align-items-center text-center"
          style={{ minHeight: "50px" }}
        >
          <i className={`${item.icon} ${item.color} fs-3 mb-1`} />
          <p className="mb-1 text-muted text-truncate w-100">
            {item.label}
          </p>
          <h6 className="fw-bold mt-auto">{item.value}</h6>
        </CardBody>
      </Card>
    </Col>
  ))}
</Row>

                {/* <AnalysisUserPanel/> */}
                 {/* <SensorModal
                      isOpen={indicatorsModal}
                      toggle={() => setIndicatorsModal(false)}
                      initialData={indicatorsData}
                      onSave={(newAlarm) => {
    setAlarms((prev) => [...prev, newAlarm]); 
  }}
                    /> */}

                 <Row className="mt-4">
  <Col xl={12}>
    <StationCycleTime />
    <LiveStationCycleTime/>
  </Col>
</Row>
<PartCountByDate/>
   
                </Container>
            </div>
            
        </React.Fragment>
    );
};

export default AdvancedAnalysis;
